import api from './api';

export async function fetchRegisterData(source, params = {}) {
  const { data } = await api.get(`/api/external-registers/${source}`, { params });
  return data;
}

export async function fetchRegisterFilterOptions(source) {
  const { data } = await api.get(`/api/external-registers/${source}/filter-options`);
  return data;
}

export async function fetchRegisterCounts() {
  const { data } = await api.get('/api/external-registers/counts');
  return data;
}

export async function fetchRegisterRecord(source, id) {
  const { data } = await api.get(`/api/external-registers/${source}/${id}`);
  return data;
}
